import { Component, Input } from '@angular/core';
import { Service } from './vapp-card.service';
import { TranslateService, TranslatePipe, LangChangeEvent } from '@ngx-translate/core';
import { GlobalVariables } from '../../../../../common/global-variables';
import { DataProtectionVariables } from '../../dataprotection-common/dataprotection-variables';
import { storageConverterRender, policyFormatter, retentionFormatter, tooltipFormatter, replicationTooltipFormatter } from '../../dataprotection-common/common-renderers';
import { AuthService } from '../../../../auth/auth.service';
import { JobConstants } from '../../../../../common/utils/job-constants';
import { JobsNotifierService } from '../../../../services/job-notifier.service';

@Component({
  selector: 'vapp-card',
  providers: [
    Service, TranslateService
  ],
  styles: [require('./vapp-card.scss')],
  template: require('./vapp-card.html')
})

export class VappCard {
  @Input('selectedVdcId') selectedVdcId;
  @Input('selectedVappId') selectedVappId;

  private subscribeHandler;
  private subscription: any;
  private isDpsAddVappPolicyPopupVisible: boolean = false;
  private isDpsEditVappPolicyPopupVisible: boolean = false;
  private isDpsRemoveVappPolicyPopupVisible: boolean = false;
  private isAdhocBackupPopupVisible: boolean = false;
  private isConfigureEmailPopupVisible: boolean = false;
  private isDpsActivityLogPopupVisible: boolean = false;
  private isRestorePointsPopupVisible: boolean = false;
  private isReplicateNowPopupVisible: boolean = false;
  private isReplicationApplyPolicyPopupVisible: boolean = false;
  private isReplicationEditPolicyPopupVisible: boolean = false;
  private isReplicationRemovePolicyPopupVisible: boolean = false;
  private dpsActivityLogPopupHeader: string;
  private dpsActivityLogPopupMode: string = DataProtectionVariables.MODES['VAPP'];
  private dpsAddVappPolicyPopupHeader: string;
  private dpsAddVappPolicyPopupMode: string = DataProtectionVariables.POLICY_POPUP_MODES['CREATE_VAPP'];
  private dpsEditVappPolicyPopupHeader: string;
  private dpsEditVappPolicyPopupMode: string = DataProtectionVariables.POLICY_POPUP_MODES['UPDATE_VAPP'];
  private dpsRemoveVappPolicyPopupHeader: string;
  private dpsRemoveVappPolicyPopupMode: string = DataProtectionVariables.MODES['VAPP'];
  private adhocBackupPopupHeader: string;
  private configureEmailPopupHeader: string;
  private restorePointPopupMode = DataProtectionVariables.RESTORE_MODES['VAPP'];
  private restorePointsPopupHeader: string;
  private replicateNowPopupHeader:string;
  private replicationApplyPolicyPopupHeader:string;
  private replicationEditPolicyPopupHeader:string;
  private replicationRemovePolicyPopupHeader:string;
  private storageConsumed: string = '';
  private policyText: string = '';
  private retentionText: string = '';
  private policyTooltip:string = ' - ';
  private jsonData: any;
  private vdcData: any;
  private loaded: boolean = false;
  private isScheduleEnabled: boolean = false;
  private replicationPolicyText: string = '';
  private replicationPolicyTooltip: string = ' - ';
  private isReplicationScheduleEnabled: boolean = false;
  private isDpsHealthy: boolean = false;

  private activityLogService = JobConstants.SERVICES['VcdDpsJob'];
  private activityLogFilter;

  constructor(public service: Service, private translateService: TranslateService,
              public authService: AuthService, private jobNotifierService: JobsNotifierService) {
    translateService.use(GlobalVariables.LOCALE);
    this.authService.getDpsHealthChangeEvent().subscribe(data => {
      this.isDpsHealthy = ( data && data.isHealthy ) ? true : false;
    });
    this.subscription = this.jobNotifierService.getCompletedJobs(this.activityLogService).subscribe(jobs => {
            this.handleJobs(jobs);
        },
        error => {},
        () => {}
    );
  }

  handleJobs(jobs) {
    for (let job of jobs) {
      if (job.hasOwnProperty('workflowType') && (job.workflowType === 'VAPP_ADHOC_BACKUP_WORKFLOW' ||
             job.workflowType === 'VAPP_RESTORE_POINT_DELETION_WORKFLOW' || job.workflowType === 'REFRESH_VAPP_RESTORE_POINTS')) {
        this.getVdcDetails();
        break;
      }
    }
  }

  ngOnInit() {
    this.isDpsHealthy = (this.authService.DPS_HEALTH && this.authService.DPS_HEALTH.isHealthy) ? true : false;
    if (this.selectedVdcId && this.selectedVappId) {
      this.getVdcDetails();
    }
  }

  ngOnChanges(changes) {
    this.activityLogFilter = 'entityId=' + this.selectedVappId;
    if (this.selectedVdcId) {
      this.getVdcDetails();
    }
  }

  ngAfterViewInit() {
  }

  ngOnDestroy() {
    if (this.subscribeHandler) {
      this.subscribeHandler.unsubscribe();
    }
    if (this.subscription) {
      this.jobNotifierService.unsubscribeService(this.activityLogService);
    }
  }

  logError(error, origin:String = '') {
    console.error('Error: ', error, (origin !== '')? " Error from " + origin : "");
  }

  logOperationCompleted(msg: string) {
    console.log('Operation Completed: ', msg)
  }

  onDPSOpenActivityLog = ($event) => {
    this.isDpsActivityLogPopupVisible = true;
    this.dpsActivityLogPopupHeader = this.translateService.instant('dpsModule.cards.vapp.dialogTitles.activityLog') + this.appendVappName();
  }

  onDPSEditPolicy = ($event) => {
    if(this.isScheduleAvailable()) {
      this.isDpsEditVappPolicyPopupVisible = true;
      this.dpsEditVappPolicyPopupHeader = this.translateService.instant('dpsModule.cards.vapp.dialogTitles.editPolicyVapp') + this.appendVappName();
    }
  }

  onDPSAddPolicy = ($event) => {
    if(!this.isScheduleAvailable()) {
      this.isDpsAddVappPolicyPopupVisible = true;
      this.dpsAddVappPolicyPopupHeader = this.translateService.instant('dpsModule.cards.vapp.dialogTitles.addPolicyVapp') + this.appendVappName();
    }
  }

  onDPSremovePolicy = ($event) => {
    if (this.isScheduleAvailable()) {
      this.isDpsRemoveVappPolicyPopupVisible = true;
      this.dpsRemoveVappPolicyPopupHeader = this.translateService.instant('dpsModule.cards.vapp.dialogTitles.removePolicyVapp') + this.appendVappName();
    }
  }

  onDPSRunAdhocBackup = ($event) => {
    this.isAdhocBackupPopupVisible = true;
    this.adhocBackupPopupHeader = this.translateService.instant('dpsModule.adhocBackup.popupHeader') + this.appendVappName();
  }

  onDPSConfigureEmail = ($event) => {
    this.isConfigureEmailPopupVisible = true;
    this.configureEmailPopupHeader = this.translateService.instant('dpsModule.configureEmail.popupHeaderVapp') + this.appendVappName();
  }

  openRestorePointDialog = ($event) => {
    this.isRestorePointsPopupVisible = true;
    this.restorePointsPopupHeader = this.translateService.instant('dpsModule.restorePoints.popupHeaderVapp') + this.appendVappName();
  }

  appendVappName() {
    let returnValue:string = '';
    if (this.jsonData && this.jsonData[0] && this.jsonData[0].name) {
        returnValue = ' - ' + this.jsonData[0].name;
    }
    return returnValue;
  }

  onDPSAddPolicyClose(event) {
    if (event && event.value) {
      this.isDpsAddVappPolicyPopupVisible = false;
      this.getVappDetails();
    }
  }

  onDPSEditPolicyClose(event) {
    if (event && event.value) {
      this.isDpsEditVappPolicyPopupVisible = false;
      this.getVappDetails();
    }
  }

  onDPSRemovePolicyClose(event) {
    if (event && event.value) {
      this.isDpsRemoveVappPolicyPopupVisible = false;
      this.getVappDetails();
    }
  }

  onAdhocBackupClose(event) {
    if (event && event.value) {
      this.isAdhocBackupPopupVisible = false;
    }
  }

  onConfigureEmailClose(event) {
    if (event && event.value) {
      this.isConfigureEmailPopupVisible = false;
    }
  }

  onReplicateNow = ($event) => {
    if (this.isReplicationScheduleAvailable('REPLICATE')) {
      this.isReplicateNowPopupVisible = true;
      this.replicateNowPopupHeader = this.translateService.instant('dpsModule.cards.vapp.dialogTitles.replicateNow') + this.appendVappName();
    }
  }

  onReplicateNowClose(event) {
    if (event && event.value) {
      this.isReplicateNowPopupVisible = false;
      this.getVappDetails();
    }
  }

  onReplicationApplyPolicy = ($event) => {
    if (this.isReplicationScheduleAvailable('APPLY')) {
      this.isReplicationApplyPolicyPopupVisible = true;
      this.replicationApplyPolicyPopupHeader = this.translateService.instant('dpsModule.cards.vapp.dialogTitles.applyReplicationPolicy') + this.appendVappName();
    }
  }

  onReplicationApplyPolicyClose(event) {
    if (event && event.value) {
      this.isReplicationApplyPolicyPopupVisible = false;
      this.getVappDetails();
    }
  }

  onReplicationEditPolicy = ($event) => {
    if (this.isReplicationScheduleAvailable(null)) {
      this.isReplicationEditPolicyPopupVisible = true;
      this.replicationEditPolicyPopupHeader = this.translateService.instant('dpsModule.cards.vapp.dialogTitles.editReplicationPolicy') + this.appendVappName();
    }
  }

  onReplicationEditPolicyClose(event) {
    if (event && event.value) {
      this.isReplicationEditPolicyPopupVisible = false;
      this.getVappDetails();
    }
  }

  onReplicationRemovePolicy = ($event) => {
    if (this.isReplicationScheduleAvailable(null)) {
      this.isReplicationRemovePolicyPopupVisible = true;
      this.replicationRemovePolicyPopupHeader = this.translateService.instant('dpsModule.cards.vapp.dialogTitles.removeReplicationPolicy') + this.appendVappName();
    }
  }

  onReplicationRemovePolicyClose(event) {
    if (event && event.value) {
      this.isReplicationRemovePolicyPopupVisible = false;
      this.getVappDetails();
    }
  }

  getVappDetails() {
    if (this.selectedVdcId && this.selectedVappId) {
      this.subscribeHandler = this.service.getVapp(this.selectedVdcId, this.selectedVappId)
        .subscribe(
          (res: any) => {
            if(res) {
              this.policyText = policyFormatter(res);
              this.retentionText = retentionFormatter(res).replace(/ \| /gi, '');
              this.policyTooltip = tooltipFormatter(res);
              this.replicationPolicyText = (res && res.replicationPolicy) ? policyFormatter(res.replicationPolicy) : '-';
              this.replicationPolicyTooltip = (res && res.replicationPolicy) ? replicationTooltipFormatter(res.replicationPolicy) : '-';
            }
            if (res && res.schedule && res.schedule.hasOwnProperty('scheduleType'))
              this.isScheduleEnabled = true;
            else
              this.isScheduleEnabled = false;
            if (res && res.statistics && res.statistics.hasOwnProperty('storageConsumed'))
              this.storageConsumed = storageConverterRender(res.statistics.storageConsumed, 'MB');

            if (res && res.replicationPolicy && res.replicationPolicy.schedule && res.replicationPolicy.schedule.hasOwnProperty('scheduleType')) {
              this.isReplicationScheduleEnabled = true;
            } else {
              this.isReplicationScheduleEnabled = false;
            }

            this.jsonData = [res];
            this.loaded = true;
          },
          error => this.logError(error, 'get vApp card details'),
          () => this.logOperationCompleted('get vApp card details')
        );
    }
    else {
      this.logError('Incorrect VDC or vApp information while fetching vApp card details');
      this.jsonData = [];
      this.policyText = '';
      this.retentionText = '';
      this.policyTooltip = ' - ';
      this.isScheduleEnabled = false;
      this.isReplicationScheduleEnabled = false;
      this.storageConsumed = storageConverterRender(0, 'MB');
      this.replicationPolicyText = '';
      this.replicationPolicyTooltip = '-';
    }
  }

  getVdcDetails() {
    if (this.selectedVdcId) {
      this.subscribeHandler = this.service.getVdcs(this.selectedVdcId)
        .subscribe(
          res => {
            this.vdcData = res;
            this.getVappDetails();
          },
          error => this.logError(error, 'get vdc card details'),
          () => this.logOperationCompleted('get vdc card details')
        );
    }
    else
      this.logError('Incorrect VDC information while fetching vdc card details');
  }

  isScheduleAvailable() {
    let retrurnValue:boolean = false;
    if (this.jsonData && this.jsonData[0] && this.jsonData[0].hasOwnProperty('schedule') && this.jsonData[0].schedule ) {
      retrurnValue = true;
    }
    return retrurnValue;
  }

  isReplicationScheduleAvailable(action) {
    let returnValue:boolean = false;
    var replicationSite = (this.vdcData && this.vdcData.hasOwnProperty('replicationSite') && this.vdcData.replicationSite) ? true : false;;
    if (action == 'REPLICATE') {
      if (replicationSite) {
        returnValue = true;
      }
    } else if (action == 'APPLY') {
      if (replicationSite &&  (!this.jsonData || !this.jsonData[0]
        || !this.jsonData[0].hasOwnProperty('replicationPolicy')
        || !this.jsonData[0].replicationPolicy)) {
          returnValue = true;
        }
    } else {
      if (replicationSite &&  (this.jsonData && this.jsonData[0]
        && this.jsonData[0].hasOwnProperty('replicationPolicy')
        && this.jsonData[0].replicationPolicy)) {
          returnValue = true;
        }
    }
    return returnValue;
  }

}



// WEBPACK FOOTER //
// ./src/app/components/dataprotection/dataprotection-vcd/vapp-card/vapp-card.component.ts